import { useEffect, useRef } from 'react'
import { MessageBubble } from './message-bubble'
import type { ChatMessage } from './chat-api'

interface MessageListProps {
  messages: ChatMessage[]
  streamingContent: string
  isStreaming: boolean
}

export function MessageList({ messages, streamingContent, isStreaming }: MessageListProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    el.scrollTop = el.scrollHeight
  }, [messages, streamingContent, isStreaming])

  const liveBubble: ChatMessage | null =
    isStreaming && streamingContent
      ? {
          id: '__streaming__',
          session_id: messages[0]?.session_id ?? '',
          workspace_id: messages[0]?.workspace_id ?? '',
          role: 'assistant',
          content: streamingContent,
          tool_calls: null,
          tool_call_id: null,
          tool_name: null,
          tokens_in: null,
          tokens_out: null,
          cost_eur: null,
          model: null,
          attachments: [],
          slash_metadata: null,
          created_at: new Date().toISOString(),
        }
      : null

  return (
    <div ref={containerRef} className="flex-1 overflow-y-auto">
      <div className="mx-auto flex w-full max-w-[720px] flex-col gap-4 px-4 py-6">
        {messages.map((m) => (
          <MessageBubble key={m.id} message={m} />
        ))}
        {liveBubble && <MessageBubble message={liveBubble} streaming />}
      </div>
    </div>
  )
}
